import "./style.css";

import lod_ from "lodash";

// Note: Display texts are now handled via i18n translations under "pickerFiles" key

// Utility function to validate attachment structure
const validateAttachment = attachment => {
	if (lod_.isNil(attachment) || !lod_.isObject(attachment)) {
		return false;
	}

	// Check for required properties
	if (
		lod_.isNil(attachment.name) ||
		!lod_.isString(attachment.name) ||
		lod_.isEmpty(attachment.name)
	) {
		return false;
	}

	// URL is required for display/download
	if (
		lod_.isNil(attachment.url) ||
		!lod_.isString(attachment.url) ||
		lod_.isEmpty(attachment.url)
	) {
		return false;
	}

	return true;
};

// Utility function to get safe attachment type
const getSafeAttachmentType = attachment => {
	if (lod_.isNil(attachment)) return null;
	return attachment.contentType || attachment.type || null;
};

// Utility function to get safe attachment name
const getSafeAttachmentName = attachment => {
	if (lod_.isNil(attachment) || lod_.isNil(attachment.name)) return null;
	return attachment.name;
};

// Utility function to get safe attachment URL
const getSafeAttachmentUrl = attachment => {
	if (lod_.isNil(attachment) || lod_.isNil(attachment.url)) return null;
	return attachment.url;
};

import Draggable from "react-draggable";
import { ResizableBox } from "react-resizable";

import React, { useEffect, useRef, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Autocomplete } from "@material-ui/lab";
import {
	Box,
	Dialog,
	DialogContent,
	DialogTitle,
	DialogActions,
	Button,
	Checkbox,
	Typography,
	IconButton,
	Tooltip,
	Chip
} from "@material-ui/core";

import i18n from "i18n";
import { Close, Visibility } from "@material-ui/icons";
import { FileIcon, defaultStyles } from "react-file-icon";
import { getFileExtension } from "./FileActions";
import engageActions from "../../redux/actions/engageActions";
import { getIntentLabel } from "helpers/utilities";
import { getMesssageItemSelector } from "redux/selectors/cockpitSelectors";
import GetChannelImage from "helpers/GetChannelImage";
import { useTheme } from "theme";

/**
 * Draggable and Resizable modal
 * @param {*} props
 * @returns
 */
function PaperComponent(props) {
	const [width, setWidth] = useState(1000);
	const [height, setHeight] = useState(600);

	const maxWidth = window.innerWidth / 1.3;
	const maxHeight = window.innerHeight / 1.3;

	return (
		<div className="pointerEventsAll">
			<Draggable bounds="body" cancel={'[class*="MuiDialogContent-root"]'} handle=".handle">
				<ResizableBox
					width={width}
					height={height}
					handle={<span className="custom-handle" />}
					minConstraints={[400, 400]}
					maxConstraints={[maxWidth, maxHeight]}
					style={{
						backgroundColor: "white",
						overflow: "visible",
						boxShadow: "rgb(0 0 0 / 25%) 0px 0px 20px 7px",
						borderRadius: "10px",
						borderBottomRightRadius: "0px"
					}}
					{...props}
				></ResizableBox>
			</Draggable>
		</div>
	);
}

/**
 * Attachement component
 * @param {*} param0
 * @returns
 */
const AttachementItem = ({ attachement, attachements, handleSelectAttachement }) => {
	const textRef = useRef(null);
	const [isOverflowing, setIsOverflowing] = useState(false);

	const { isDarkMode } = useTheme();

	useEffect(() => {
		if (textRef.current) {
			setIsOverflowing(textRef.current.scrollWidth > textRef.current.clientWidth);
		}
	}, []);

	// Validate attachment before processing
	if (!validateAttachment(attachement)) {
		return (
			<Box
				className="attachementContainer"
				style={{
					border: "1px solid #f44336",
					backgroundColor: "#ffebee",
					opacity: 0.6
				}}
				sx={{ m: 1, p: 1 }}
			>
				<Box style={{ color: "#f44336", fontStyle: "italic" }}>
					{i18n.t("pickerFiles.MALFORMED_FILE")}
				</Box>
			</Box>
		);
	}

	const [checked, setChecked] = useState(attachements.includes(attachement));

	let attachementType = getSafeAttachmentType(attachement);

	const handleDisplayPicture = attachment => {
		if (!validateAttachment(attachment)) {
			// console.error("Cannot display invalid attachment", attachment);
			return;
		}

		let name = getSafeAttachmentName(attachment);
		let url = getSafeAttachmentUrl(attachment);

		if (lod_.isNil(url)) {
			// console.error("Cannot display attachment without URL", attachment);
			return;
		}

		let type = attachementType ? ` type='${attachementType}'` : "";

		const ext = (name || url || "").split(".").pop().toLowerCase();
		const isVideo =
			["mp4", "mov", "webm", "ogg"].includes(ext) ||
			(attachementType && attachementType.startsWith("video/"));

		const css = `<html><head><title>${name || i18n.t("pickerFiles.DEFAULT_FILE_PREFIX")}</title>`;
		let img =
			'<object style="width:100%;height:100%;margin:0 auto;" data="' + url + '"' + type + "/>";
		let body = '<body style="width:100%;height:100%;margin:0 auto;">';
		let header = null;

		const officeMimeTypes = [
			"application/msword",
			"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
			"application/vnd.ms-excel",
			"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			"application/vnd.ms-powerpoint",
			"application/vnd.openxmlformats-officedocument.presentationml.presentation"
		];

		if (type.indexOf("pdf") === -1) {
			body =
				'<body style="margin: 0;transform: translate(-50%, -50%);left: 50%;top: 50%;position: absolute;">';
			img =
				'<object style="max-width:100vw;max-height:100vh;margin:0 auto;" data="' +
				url +
				'"' +
				type +
				"/>";
		}

		if (!lod_.isNil(attachment?.mimeType) && officeMimeTypes.includes(attachment?.mimeType)) {
			header =
				" <style>  iframe { width: 100%; height: 100vh; border: none; } body {  margin: 0; } </style></head>";
			body =
				"<body> <iframe src=https://view.officeapps.live.com/op/embed.aspx?src=" +
				url +
				"></iframe>";
			img = null;
		}
		if (isVideo) {
			header = `<style>body{margin:0;padding:0;background:#000;} video{display:block;margin:auto;max-width:100vw;max-height:100vh;} object{width:100vw;height:100vh;} iframe{width:100vw;height:100vh;border:none;}</style>`;

			// Affichage vidéo plein écran avec contrôles
			body = `<body><video src='${url}' controls autoplay style='background:#000;'></video></body>`;
			img = null;
		}

		const popup = window.open("");
		popup.document.write(css);
		if (!lod_.isNil(header)) {
			popup.document.write(header);
		}
		popup.document.write(body);
		if (!lod_.isNil(img)) {
			popup.document.write(img);
		}
		popup.document.write("</body></html>");
		popup.document.close();
	};

	const handleSelect = () => {
		handleSelectAttachement(attachement);
	};

	useEffect(() => {
		setChecked(attachements.includes(attachement));
	}, [attachements]);

	return (
		<Box
			className="attachementContainer"
			style={{
				border: isDarkMode
					? "1px solid rgba(255, 255, 255, 0.12)"
					: checked
						? ""
						: "1px solid #ccc",
				width: "24%",
				backgroundColor: isDarkMode
					? checked
						? "#22334a" // bleu foncé sélectionné
						: "var(--dark-bg-history)"
					: checked
						? "rgb(238 238 238)"
						: "white"
			}}
			sx={{ m: 1, p: 1 }}
			onClick={() => handleSelect()}
		>
			{attachementType?.includes("image") ? (
				<Box
					component="img"
					alt={getSafeAttachmentName(attachement) || i18n.t("pickerFiles.UNKNOWN_FILE")}
					src={getSafeAttachmentUrl(attachement)}
					style={{ width: "100%", height: "90%" }}
					onError={e => {
						// Hide image and show file icon fallback
						e.target.style.display = "none";
						const fallback = e.target.nextSibling;
						if (fallback) fallback.style.display = "block";
					}}
				/>
			) : null}
			<div
				style={{
					display: attachementType?.includes("image") ? "none" : "block",
					height: "80%",
					width: "80%",
					alignItems: "center"
				}}
			>
				<FileIcon
					extension={(() => {
						const name = getSafeAttachmentName(attachement);
						if (lod_.isNil(name)) return "txt";
						const ext = getFileExtension(name).replace(".", "");
						return lod_.isEmpty(ext) ? "txt" : ext;
					})()}
					{...(() => {
						const name = getSafeAttachmentName(attachement);
						if (lod_.isNil(name)) return defaultStyles.txt || {};
						const ext = getFileExtension(name).replace(".", "").toLowerCase();
						return defaultStyles[ext] || defaultStyles.txt || {};
					})()}
				/>
			</div>
			<Tooltip title={isOverflowing ? attachement.name : ""} disableHoverListener={!isOverflowing}>
				<Box
					ref={textRef}
					style={{
						whiteSpace: "nowrap",
						overflow: "hidden",
						textOverflow: "ellipsis",
						width: "80%"
					}}
				>
					{getSafeAttachmentName(attachement) || i18n.t("pickerFiles.UNKNOWN_FILE")}
				</Box>
			</Tooltip>
			{/* <Box>{getSafeAttachmentName(attachement) || i18n.t("pickerFiles.UNKNOWN_FILE")}</Box> */}
			<Box className="attachementContainerCheckbox">
				<Checkbox checked={checked} color="primary" />
				<Box className="attachementContainerView">
					<Tooltip placement="top" title="Visualiser">
						<IconButton
							onClick={e => {
								e.stopPropagation();
								handleDisplayPicture(attachement);
							}}
						>
							<Visibility />
						</IconButton>
					</Tooltip>
				</Box>
			</Box>
		</Box>
	);
};

/**
 * HSH Specific action to create an affair
 * @param {function} props.handleClose - Close the modal
 * @returns {JSX.Element} - JSX component
 */
const PickerFiles = ({ handleClose }) => {
	const dispatch = useDispatch();

	const aConfig = useSelector(getMesssageItemSelector, shallowEqual);
	const intents = aConfig?.intents ?? [];
	// All attachements of the last message (cannot be modified)
	const [attachements, setAttachements] = useState([]);
	// Attachements selected by the user (can be modified)
	const [selectedAttachements, setSelectedAttachements] = useState([]);
	const [selectedChannel, setSelectedChannel] = useState({});
	const { assistantconfig } = useSelector(state => state);

	const { selectedConversation } = useSelector(state => {
		return {
			selectedConversation: state.cockpit.selectedConversation
		};
	});

	useEffect(() => {
		if (
			!lod_.isNil(selectedConversation.messages) &&
			!lod_.isEmpty(selectedConversation.messages)
		) {
			let allAttachements = [];

			for (let message of selectedConversation.messages) {
				try {
					if (
						message?.header?.version === 5 ||
						message?.header?.format_version === 4 ||
						!lod_.isNil(message?.payload?.payload)
					) {
						if (!lod_.isEmpty(message.payload?.payload?.attachments)) {
							// Validate and filter attachments before adding
							const validAttachments = message.payload.payload.attachments.filter(attachment => {
								const isValid = validateAttachment(attachment);
								if (!isValid) {
									// console.warn("Invalid attachment found and filtered out:", attachment);
								}
								return isValid;
							});
							allAttachements.push(...validAttachments);
						}
					} else {
						if (!lod_.isEmpty(message.body?.attachments)) {
							// Validate and filter attachments before adding
							const validAttachments = message.body.attachments.filter(attachment => {
								const isValid = validateAttachment(attachment);
								if (!isValid) {
									// console.warn("Invalid attachment found and filtered out:", attachment);
								}
								return isValid;
							});
							allAttachements.push(...validAttachments);
						}
					}
				} catch (error) {
					// console.error("Error processing message attachments:", error, message);
				}
			}

			// Set attachements values
			setSelectedAttachements(allAttachements);
			setAttachements(allAttachements);
		}
	}, []);

	function handleSelectAttachement(attachement) {
		if (selectedAttachements.includes(attachement)) {
			setSelectedAttachements(selectedAttachements.filter(item => item !== attachement));
		} else {
			setSelectedAttachements([...selectedAttachements, attachement]);
		}
	}

	function launchForward() {
		const title = selectedConversation.meta?.topic
			? getIntentLabel(selectedConversation.meta?.topic, intents)
			: getIntentLabel(selectedConversation.meta?.cockpit.title, intents);

		let initialDraft = {
			attachments: [...selectedAttachements],
			isConvForward: true,
			draftTransfer: {
				subject: title || ""
			}
		};
		const originFID = selectedConversation?.header?.fID;

		dispatch(engageActions.createEngageConversation(selectedChannel.code, initialDraft, originFID));
		handleClose();
	}

	return (
		<Dialog
			open
			aria-labelledby="draggable-dialog-title"
			fullWidth
			maxWidth="lg"
			hideBackdrop={true}
			PaperComponent={PaperComponent}
			style={{
				pointerEvents: "none"
			}}
		>
			<DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title" className="handle">
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center"
					}}
				>
					<div>{i18n.t("TabAction.forwardConfig")}</div>
					<div>
						<IconButton onClick={handleClose}>
							<Close />
						</IconButton>
					</div>
				</div>
			</DialogTitle>
			<DialogContent className="handle">
				<Typography variant="h5" gutterBottom>
					{i18n.t("TabAction.selectChannel")}
				</Typography>
				<Box sx={{ flexGrow: 1, mb: 2 }}>
					<span
						style={{
							display: "flex",
							flexWrap: "wrap",
							width: "100%",
							paddingBottom: "2%"
						}}
					>
						{assistantconfig?.channels
							.filter(a => a.engage === true)
							.sort((a, b) => {
								// Priorité aux objets ayant `bool: true`
								if (a.favorite === true && b.favorite !== true) return -1;
								if (b.favorite === true && a.favorite !== true) return 1;

								// Ensuite, tri alphabétique sur `data`
								return a.name.localeCompare(b.name);
							})
							.map(channel => {
								return (
									<Box
										key={channel.code}
										style={{
											paddingRight: "2%",
											paddingTop: "2%"
										}}
									>
										<Chip
											label={channel.name}
											style={{ textTransform: "capitalize" }}
											color={channel.code === selectedChannel.code ? "primary" : "default"}
											icon={
												<img
													src={GetChannelImage(
														assistantconfig?.channels,
														channel.code.toUpperCase(),
														channel
													)}
													alt="logo_dropdown"
													width="25"
													height="25"
													className="logo-channel"
												/>
											}
											clickable={true}
											onClick={() => {
												setSelectedChannel(channel);
											}}
										/>
									</Box>
								);
							})}
					</span>
				</Box>
				<Typography variant="h5" gutterBottom>
					{i18n.t("TabAction.selectPJ")}
				</Typography>
				<Box sx={{ flexGrow: 1, mt: 2 }}>
					<Box
						style={{
							display: "flex",
							flexWrap: "wrap",
							justifyContent: "center"
						}}
					>
						{lod_.isEmpty(attachements) && (
							<Box>
								<Typography>
									<i>Aucune pièce jointe trouvée</i>
								</Typography>
							</Box>
						)}
						{attachements.map((attachement, index) => {
							return (
								<AttachementItem
									key={index}
									attachement={attachement}
									attachements={selectedAttachements}
									handleSelectAttachement={handleSelectAttachement}
								/>
							);
						})}
					</Box>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button style={{ color: "red" }} onClick={handleClose}>
					{i18n.t("TabAction.cancel")}
				</Button>
				<Button
					color="primary"
					autoFocus
					onClick={launchForward}
					disabled={lod_.isEmpty(selectedChannel)}
				>
					{i18n.t("COC.forward")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default PickerFiles;
